import React from 'react';
// import { useTranslation } from 'react-i18next';

import Select from '../../../common2/Select';
import { Input } from '../../../common2/Input/Input';
import useOnFormChange from '../../../../hooks/useOnFormChange';

import styles from './OrderItemsTaxInputs.scss';
import { ClaimContext } from '../types';

const taxTypeOptions = [
  { value: true, label: 'TAX_TYPE_INCLUSIVE' },
  { value: false, label: 'TAX_TYPE_EXCLUSIVE' },
];

type OrderItemsTaxInputsProps = {
  isTaxIncluded?: boolean;
  taxRate?: number | null | string;
  onChange: (data: Partial<ClaimContext>) => void;
  errors: Record<string, string>;
  isDisabled?: boolean;
};

function OrderItemsTaxInputs(props: OrderItemsTaxInputsProps) {
  const { isTaxIncluded, taxRate, onChange, errors, isDisabled = false } = props;

  const onInputChange = useOnFormChange(onChange);

  return (
    <div className={styles.container}>
      <Select
        label="Tax Type"
        name="isTaxIncluded"
        value={isTaxIncluded}
        options={taxTypeOptions}
        onChange={onInputChange}
        error={errors.taxType}
        isRequired
        disabled={isDisabled}
      />
      {isTaxIncluded && (
        <Input
          name="taxRate"
          label="Tax Rate"
          value={taxRate?.toString() || ''}
          error={errors.taxRate}
          onChange={onInputChange}
          placeholder="0.0"
          rightElement="%"
          isRequired
          disabled={isDisabled}
        />
      )}
    </div>
  );
}

export default React.memo(OrderItemsTaxInputs);
